import {Inject, Pipe, PipeTransform} from '@angular/core';
import {
  EAttachableType, EPlatform, EUnitType,
  FloorDrawVersionModel,
  MessageAttachmentsModel, SubUnitFloorModel, TUnitFloors,
  UnitUserModel,
} from '@atlas-workspace/shared/models';
import {ReclamationAdminService, ReclamationClientService} from "@atlas-workspace/shared/service";
import {WEB_PLATFORM_TYPE} from "@atlas-workspace/shared/translate";
import {UntilDestroy} from "@ngneat/until-destroy";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@UntilDestroy()
@Pipe({
  name: 'threadMessageChangeRequest',
  standalone: true,
})
export class ThreadMessageChangeRequestPipe implements PipeTransform {
  constructor(
    @Inject(WEB_PLATFORM_TYPE) private platformType: EPlatform,
    private readonly reclamationAdminService: ReclamationAdminService,
    private readonly reclamationClientService: ReclamationClientService,
  ) {}
  transform(
    message: MessageAttachmentsModel,
    version: FloorDrawVersionModel[],
    unit: UnitUserModel,
    projectId: number
  ): Observable<FloorDrawVersionModel | TUnitFloors | undefined> {
    if (message.attachableType === EAttachableType.FloorVersion) {
      return of(version.find((v) => v.id === message.attachableId));
    } else {
      if (unit.propertyType === EUnitType.CommonArea) {
        if (!message.subUnitId) return of(undefined);
        return this.platformType === EPlatform.WEB_ADMIN
          ? this.getAdminSubUnitFloor(projectId, unit.id, message.subUnitId, message.attachableId)
          : this.getClientSubUnitFloor(projectId, unit.id, message.subUnitId, message.attachableId);
      } else {
        const floors = unit.hasOwnFloorPlans ? unit.unitFloors : unit.floors;
        return of(floors?.find((f) => f.id === message.attachableId));
      }
    }
  }

  getAdminSubUnitFloor(projectId: number, unitId: number, subUnitId: number, floorId: number): Observable<SubUnitFloorModel | undefined> {
    return this.reclamationAdminService.getFloorListOfSubUnit(projectId.toString(), unitId, subUnitId).pipe(
      map(value => value.find(item => item.id === floorId))
    );
  }

  getClientSubUnitFloor(projectId: number, unitId: number, subUnitId: number, floorId: number): Observable<SubUnitFloorModel | undefined> {
    return this.reclamationClientService.getFloorListOfSubUnit(projectId.toString(), unitId, subUnitId).pipe(
      map(value => value.find(item => item.id === floorId))
    );
  }
}
